angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/profiles/profile.html',
    '<!-- Profile -->\n' +
    '<update-title ng-if="profileData.user.IsProfessional" title="Engineer In {{profileData.user.City|capitalize}}, {{profileData.user.State|capitalize}} | {{profileData.user.FirstName}} {{profileData.user.LastName.substring(0,1)}}. | PEforHire.com"></update-title>\n' +
    '<update-meta ng-if="profileData.user.IsProfessional" name="description" content="View {{profileData.user.FirstName}}\'s resume, work experience and qualifications. Send a request for proposal. {{engineerLicenses}}"></update-meta>\n' +
    '<section class="content dashboard">\n' +
    '	<div class="container">\n' +
    '		<div class="row">\n' +
    '			<div class="col-xs-12 col-sm-8" ng-cloak>\n' +
    '				<h2 ng-if="profileData.user.IsClient">Profile</h2>\n' +
    '				<h2 ng-if="profileData.user.IsProfessional">Engineer Profile</h2>\n' +
    '				<div class="dashboard-box">\n' +
    '					<a class="btn btn-primary btn-small" href="" ui-sref="edit-profile" ng-if="user.Id == profileData.user.Id">Edit\n' +
    '						<span class="hidden-xs"> Profile</span>\n' +
    '					</a>\n' +
    '					<ul class="list-inline user-profile">\n' +
    '						<div class="travel-map hidden-xs">\n' +
    '							<div class="travel-g-map" ng-if="profileData.user.IsProfessional">\n' +
    '								<ng-map zoom="7" class="travel-g-map" default-style="false" center="{{latLng}}">\n' +
    '									<marker position="{{latLng}}"></marker>\n' +
    '									<shape id="circle" name="circle" stroke-color=\'#0784b3\' stroke-opacity="0.8" stroke-weight="2" fill-color=\'#0784b3\' center="{{latLng}}"\n' +
    '									 radius="{{distance}}"></shape>\n' +
    '								</ng-map>\n' +
    '							</div>\n' +
    '							<small ng-show="profileData.user.IsProfessional && profileData.user.travelDistance">Travel Distance: {{profileData.user.travelDistance}}\n' +
    '								<span ng-show="profileData.user.travelDistance != noTravelLimits">Miles</span>\n' +
    '							</small>\n' +
    '						</div>\n' +
    '						<li class="user-profile-photo">\n' +
    '							<!-- Keep second background-image avater.png as is! Replace first [avatar-01.jpg] with user\'s photo -->\n' +
    '							<div class="user-photo" style="background-image:url({{profileData.user.Picture.Url}}),url(assets/img/avatar.png);"></div>\n' +
    '							<!-- Rating -->\n' +
    '							<div class="rating profile" ng-show="profileData.user.IsProfessional">\n' +
    '								<span ng-repeat="i in [5, 4, 3, 2, 1]" ng-class="{\'on\': i <= profileData.user.AverageScore}"></span>\n' +
    '							</div>\n' +
    '						</li>\n' +
    '						<li class="user-info">\n' +
    '							<!-- Profile Info -->\n' +
    '							<h4 ng-if="user">{{profileData.user.FirstName}} {{profileData.user.LastName}}</h4>\n' +
    '							<h4 ng-if="!user">{{profileData.user.FirstName}} {{profileData.user.LastName.substring(0,1)}}.</h4>\n' +
    '							<address>\n' +
    '								<div ng-if="profileData.user.City || profileData.user.State">\n' +
    '									<i class="fa fa-map-marker fa-fw" ng-if="profileData.user.City || profileData.user.State"></i>\n' +
    '									<span ng-if="::profileData.user.City"> {{::profileData.user.City}},</span> {{::profileData.user.State}}\n' +
    '								</div>\n' +
    '								<div ng-if="::profileData.user.WebSiteRoot">\n' +
    '									<i class="fa fa-phone fa-globe fa-fw"></i>\n' +
    '								</div>\n' +
    '								<a ng-href="//{{::profileData.user.WebSiteRoot}}" target="_blank">{{::profileData.user.WebSiteRoot}}</a>\n' +
    '							</address>\n' +
    '							<span ng-if="profileData.user.IsProfessional" ng-repeat="license in groupedLicenses">\n' +
    '								<license-icon license={{license}} licenses={{licenses}}></license-icon>\n' +
    '							</span>\n' +
    '						</li>\n' +
    '					</ul>\n' +
    '				</div>\n' +
    '				<div class="dashboard-box" ng-show="::profileData.user.IsProfessional" ng-cloak>\n' +
    '					<h4>Professional Information</h4>\n' +
    '					<div class="row">\n' +
    '						<div class="col-sm-12 col-md-11 user-profile-descr" style="white-space: pre-wrap;">{{profileData.user.Bio}}</div>\n' +
    '					</div>\n' +
    '				</div>\n' +
    '				<div class="dashboard-box" ng-show="::profileData.user.IsProfessional" ng-cloak>\n' +
    '					<div class="profile-feedback-number">{{feedbackList.length}}</div>\n' +
    '					<h4 ng-if="user.Id == profileData.user.Id">My Feedback</h4>\n' +
    '					<h4 ng-if="user.Id != profileData.user.Id">Feedback</h4>\n' +
    '					<div class="row">\n' +
    '						<div class="col-sm-12 col-md-11 user-profile-feedback" ng-repeat="feedback in feedbackList">\n' +
    '							<small>{{::feedback.ReviewDate | localeDateHuman}}</small>\n' +
    '							<div class="rating">\n' +
    '								<span ng-class="{\'on\': feedback.Score > 4}"></span>\n' +
    '								<span ng-class="{\'on\': feedback.Score > 3}"></span>\n' +
    '								<span ng-class="{\'on\': feedback.Score > 2}"></span>\n' +
    '								<span ng-class="{\'on\': feedback.Score > 1}"></span>\n' +
    '								<span ng-class="{\'on\': feedback.Score > 0}"></span>\n' +
    '							</div>\n' +
    '							<a ng-if="user.IsProfessional" ui-sref="project({uid: feedback.ProjectUID})">\n' +
    '								<h4>{{::feedback.ProjectTitle}}</h4>\n' +
    '							</a>\n' +
    '							<h4 ng-if="user.IsClient">{{::feedback.ProjectTitle}}</h4>\n' +
    '							<blockquote>\n' +
    '								<h5 style="word-wrap: break-word;">{{::feedback.Review}}</h5>\n' +
    '							</blockquote>\n' +
    '							<span class="author" ng-if="user.IsProfessional">{{::feedback.ClientFirstName}} {{::feedback.ClientLastName}}</span>\n' +
    '							<span class="author" ng-if="user.IsClient">{{::feedback.ClientFirstName}} {{::feedback.ClientLastName.charAt(0)}}.</span>\n' +
    '						</div>\n' +
    '\n' +
    '					</div>\n' +
    '					<a class="show-more" href="" ng-click="loadFeedbackList()" ng-show="feedbackRequest.length!=feedbackList.length">Show more</a>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '			<!-- Request Engineer -->\n' +
    '			<div class="col-xs-12 col-sm-4" ng-if="!user || !user.IsProfessional">\n' +
    '				<h3 class="mt30">Request Engineer\n' +
    '					<a ng-click="help()" class="fa fa-question-circle small" title="Request Engineer" data-toggle="modal" href=""></a>\n' +
    '				</h3>\n' +
    '				<div class="text-muted mb30">\n' +
    '					<div ng-if="!user">\n' +
    '						<a href="" ui-sref="login">LOG IN</a> &nbsp;or&nbsp;\n' +
    '						<a href="" ui-sref="post-project">POST PROJECT</a>\n' +
    '					</div>\n' +
    '				</div>\n' +
    '				<!-- Propos -->\n' +
    '				<form ng-disabled="!user.IsClient">\n' +
    '					<label class="select input-aside pull-left">\n' +
    '						<select ng-disabled="!user.IsClient" ng-options="p.Title for p in userProjects" ng-model="requestProposalData.project" class="form-control input-lg">\n' +
    '							<option value="">Select your project</option>\n' +
    '						</select>\n' +
    '					</label>\n' +
    '					<button ng-click="requestProposal()" ng-disabled="!user.IsClient" type="button" class="btn btn-primary btn-lg btn-aside">Send</button>\n' +
    '				</form>\n' +
    '			</div>\n' +
    '			<div class="col-xs-12 col-sm-4 work-history" ng-show="projectHistoryRequest.length!=0" ng-cloak>\n' +
    '				<div class="profile-feedback-number alt">{{projectHistoryRequest.length}}</div>\n' +
    '				<!-- Projects History -->\n' +
    '				<h3 class="mb30" ng-if="profileData.user.IsClient">Projects History</h3>\n' +
    '				<h3 class="mb30" ng-if="profileData.user.IsProfessional">Work History</h3>\n' +
    '				<ul class="list-group no-shadow bullets-c-style">\n' +
    '					<li class="list-group-item " ng-repeat="project in projectHistoryList">\n' +
    '						<a ng-if="!(user.IsClient && profileData.user.Id != user.Id)" ui-sref="project({uid: project.UID})" style="word-wrap: break-word;">{{::project.Title}}</a>\n' +
    '						<span ng-if="(user.IsClient && profileData.user.Id != user.Id)" style="word-wrap: break-word;">{{::project.Title}}</span>\n' +
    '						<br>\n' +
    '						<small>{{::project.HiredDate | localeDateHuman}}</small>\n' +
    '					</li>\n' +
    '				</ul>\n' +
    '				<a class="show-more" href="" ng-click="loadProjectHistoryList()" ng-show="projectHistoryRequest.length!=projectHistoryList.length"\n' +
    '				 ng-cloak>Show more</a>\n' +
    '			</div>\n' +
    '			<div class="col-xs-12 col-sm-4" ng-show="projectHistoryRequestLoaded && projectHistoryRequest.length==0 && profileData.user.IsClient"\n' +
    '			ng-cloak>\n' +
    '			   <hr class="mt40 mb40">\n' +
    '			   <div class="text-right">\n' +
    '				   <a href="" ui-sref="resources({\'section\':\'faq\'})">See FAQs&nbsp;\n' +
    '					   <i class="fa fa-angle-right fa-lg"></i>\n' +
    '				   </a>\n' +
    '			   </div>\n' +
    '		   </div>\n' +
    '		   <div class="col-xs-12 col-sm-4" ng-show="projectHistoryRequestLoaded && projectHistoryRequest.length==0 && profileData.user.IsProfessional"\n' +
    '			ng-cloak>\n' +
    '			   <hr class="mt40 mb40">\n' +
    '			   <div class="text-right">\n' +
    '				   <a href="" ui-sref="resources({\'section\':\'faq\'})">See FAQs&nbsp;\n' +
    '					   <i class="fa fa-angle-right fa-lg"></i>\n' +
    '				   </a>\n' +
    '			   </div>\n' +
    '		   </div>\n' +
    '		</div>\n' +
    '	</div>\n' +
    '</section>\n' +
    '\n' +
    '\n' +
    '<script type="text/ng-template" id="requestProposalSuccessModal.html">\n' +
    '	<div class="modal-header">\n' +
    '			<a ng-click="$close();" class="close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times"></i></a>\n' +
    '			<h4 class="modal-title">Sent!</h4>\n' +
    '		</div>\n' +
    '	<div class="modal-body">\n' +
    '			<p>Your request has been sent to the Engineer.</p>\n' +
    '	</div>\n' +
    '	<div class="modal-footer">\n' +
    '			<button ng-click="$close();" type="button" class="btn btn-default" data-dismiss="modal">Close</button>\n' +
    '		</div>\n' +
    '</script>\n' +
    '<script type="text/ng-template" id="requestProposalHelp.html">\n' +
    '	<div class="modal-header">\n' +
    '		<a ng-click="$close();" class="close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times"></i></a>\n' +
    '		<h4 class="modal-title">Request Engineer</h4>\n' +
    '	</div>\n' +
    '	<div class="modal-body">\n' +
    '		<p>\n' +
    '			Use this option to request this\n' +
    '			Engineer for your project. Click\n' +
    '			<a ui-sref="post-project">here</a> to create a new project or\n' +
    '			<a href="" ui-sref="login">\n' +
    '			login\n' +
    '			</a>to send an existing project.\n' +
    '			Your contact information will NOT\n' +
    '			be shared with the Engineer.\n' +
    '		</p>\n' +
    '	</div>\n' +
    '	<div class="modal-footer">\n' +
    '		<button ng-click="$close();" type="button" class="btn btn-primary" data-dismiss="modal">OK</button>\n' +
    '	</div>\n' +
    '</script>');
}]);
